import { useState, useEffect } from "react";

const SC = {
  "in-progress":{lbl:"En cours",c:"#5b6ef8"},
  "pending":    {lbl:"Planifié",c:"#f5a623"},
  "planifiee":  {lbl:"Planifié",c:"#f5a623"},
  "en_cours":   {lbl:"En cours",c:"#5b6ef8"},
  "completed":  {lbl:"Terminé", c:"#22d3a0"},
  "terminee":   {lbl:"Terminé", c:"#22d3a0"},
  "cancelled":  {lbl:"Annulé",  c:"#ef4444"},
  "annulee":    {lbl:"Annulé",  c:"#ef4444"},
  "brouillon":  {lbl:"Brouillon",c:"#8899bb"},
};
const PC = {
  "urgent":{lbl:"Urgent",c:"#ef4444"},
  "urgente":{lbl:"Urgent",c:"#ef4444"},
  "high":  {lbl:"Haute", c:"#f5a623"},
  "haute": {lbl:"Haute", c:"#f5a623"},
  "medium":{lbl:"Moyenne",c:"#5b6ef8"},
  "normale":{lbl:"Normale",c:"#5b6ef8"},
  "low":   {lbl:"Basse", c:"#22d3a0"},
  "basse": {lbl:"Basse", c:"#22d3a0"},
};
const NEXT = {
  "pending":     [{s:"en_cours",lbl:"▶ Démarrer",c:"#5b6ef8"},{s:"annulee",lbl:"✕ Annuler",c:"#ef4444"}],
  "planifiee":   [{s:"en_cours",lbl:"▶ Démarrer",c:"#5b6ef8"},{s:"annulee",lbl:"✕ Annuler",c:"#ef4444"}],
  "brouillon":   [{s:"en_cours",lbl:"▶ Démarrer",c:"#5b6ef8"},{s:"annulee",lbl:"✕ Annuler",c:"#ef4444"}],
  "in-progress": [{s:"terminee",lbl:"✓ Terminer",c:"#22d3a0"},{s:"planifiee",lbl:"⏸ Pause",  c:"#f5a623"}],
  "en_cours":    [{s:"terminee",lbl:"✓ Terminer",c:"#22d3a0"},{s:"planifiee",lbl:"⏸ Pause",  c:"#f5a623"}],
  "completed":   [{s:"en_cours",lbl:"↩ Réouvrir",c:"#5b6ef8"}],
  "terminee":    [{s:"en_cours",lbl:"↩ Réouvrir",c:"#5b6ef8"}],
  "cancelled":   [{s:"planifiee",lbl:"↩ Réouvrir",c:"#5b6ef8"}],
  "annulee":     [{s:"planifiee",lbl:"↩ Réouvrir",c:"#5b6ef8"}],
};

const MODELE_LABELS = {
  pack_sentinelle: "📷 Pack Sentinelle",
  pack_flash: "🚨 Pack Flash Control",
  maintenance: "🔧 Maintenance",
  depannage: "🛠️ Dépannage",
};

const BASE = "https://support.gs-group.fr/api";
const hdr = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + localStorage.getItem("nexo_token") });

export default function IntDetail({ T, intervention, onClose, onUpdated, onOpenPV, onShowSuggestions, onExportPDF, onFicheConsigne, onZonesCameras, onChecklist, onNonConf }) {
  const [updating, setUpdating] = useState(false);
  const [showReassign, setShowReassign] = useState(false);
  const [techniciens, setTechniciens] = useState([]);
  const [newTech, setNewTech] = useState("");
  const [comment, setComment] = useState("");
  const [showMap, setShowMap] = useState(false);
  const [sendingLink, setSendingLink] = useState(false);
  const [sigToast, setSigToast] = useState("");
  const [showSigForm, setShowSigForm] = useState(false);
  const [sigEmail, setSigEmail] = useState("");
  const i = intervention;

  const showSigToast = (msg) => { setSigToast(msg); setTimeout(() => setSigToast(""), 3500); };

  const sendSignatureLink = async () => {
    if (!sigEmail.trim()) return;
    setSendingLink(true);
    try {
      const r = await fetch(`${BASE}/interventions/${i.id}/send-signature-link`, {
        method: "POST", headers: hdr(),
        body: JSON.stringify({ email: sigEmail.trim() }),
      });
      let d = {}; try { d = await r.json(); } catch {}
      if (!r.ok) {
        showSigToast("❌ " + (d.error || `Erreur ${r.status}`));
      } else if (d.emailOk === false) {
        if (d.signUrl) {
          try { await navigator.clipboard.writeText(d.signUrl); } catch {}
          showSigToast("⚠️ SMTP non configuré — lien copié dans le presse-papier");
        } else {
          showSigToast("⚠️ Email non envoyé : " + (d.emailError || "erreur SMTP"));
        }
      } else {
        showSigToast("📧 Lien envoyé à " + sigEmail.trim());
        setShowSigForm(false);
      }
    } catch { showSigToast("❌ Impossible de joindre le serveur"); }
    setSendingLink(false);
  };
  const statut = i.statut || "pending";

  useEffect(()=>{
    fetch("https://support.gs-group.fr/api/users/techniciens",{
      headers:{Authorization:"Bearer "+localStorage.getItem("nexo_token")}
    }).then(r=>r.json()).then(d=>setTechniciens(Array.isArray(d)?d:[]));
  },[]);

  const changeStatut = async (s) => {
    setUpdating(true);
    try {
      await fetch(`https://support.gs-group.fr/api/interventions/${i.id}/statut`,{
        method:"PATCH",
        headers:{"Content-Type":"application/json",Authorization:"Bearer "+localStorage.getItem("nexo_token")},
        body: JSON.stringify({statut:s})
      });
      onUpdated && onUpdated({...i, statut: s});
    } catch(e){}
    setUpdating(false);
  };

  const reassigner = async () => {
    if (!newTech) return;
    setUpdating(true);
    await fetch(`https://support.gs-group.fr/api/interventions/${i.id}/assigner`,{
      method:"PATCH",
      headers:{"Content-Type":"application/json",Authorization:"Bearer "+localStorage.getItem("nexo_token")},
      body: JSON.stringify({technicien_id:newTech, commentaire:comment||"Réassignation"})
    });
    setShowReassign(false);
    onUpdated && onUpdated({...i, technicien_id:newTech});
    setUpdating(false);
  };

  const steps = ["planifiee","en_cours","terminee"];
  const stepLabels = ["Planifié","En cours","Terminé"];
  const norm = {pending:"planifiee","in-progress":"en_cours",completed:"terminee",brouillon:"planifiee"};
  const ns = norm[statut]||statut;
  const currentIdx = steps.indexOf(ns);

  const COLORS = ["#5b6ef8","#22d3a0","#f5a623","#a855f7","#ef4444"];
  const adresseComplete = [i.client_adresse, i.client_ville, i.client_cp, "France"].filter(Boolean).join(", ");
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(adresseComplete)}`;
  const osmEmbedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${(i.map_lng||i.client_lng||7.35)-0.01},${(i.map_lat||i.client_lat||47.75)-0.01},${(i.map_lng||i.client_lng||7.35)+0.01},${(i.map_lat||i.client_lat||47.75)+0.01}&layer=mapnik&marker=${i.map_lat||i.client_lat||47.75},${i.map_lng||i.client_lng||7.35}`;

  return (
    <>
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:600,maxHeight:"92vh",overflowY:"auto"}}>

        {/* Header */}
        <div style={{padding:"22px 24px 0",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div style={{flex:1}}>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <span style={{fontSize:10,color:T.muted,fontFamily:"monospace"}}>INT-{String(i.id||"").slice(-8).toUpperCase()}</span>
              {SC[statut]&&<span style={{fontSize:11,fontWeight:700,color:SC[statut].c,background:SC[statut].c+"22",padding:"2px 9px",borderRadius:20,textTransform:"uppercase"}}>{SC[statut].lbl}</span>}
              {PC[i.priorite]&&<span style={{fontSize:11,fontWeight:700,color:PC[i.priorite].c,background:PC[i.priorite].c+"22",padding:"2px 9px",borderRadius:20}}>{PC[i.priorite].lbl}</span>}
              {i.modele_pv&&<span style={{fontSize:11,fontWeight:700,color:T.accent,background:T.accentDim,padding:"2px 9px",borderRadius:20}}>{MODELE_LABELS[i.modele_pv]||i.modele_pv}</span>}
            </div>
            <div style={{fontSize:21,fontWeight:800,color:T.text,letterSpacing:"-0.5px"}}>{i.titre}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22,marginLeft:12}}>✕</button>
        </div>

        <div style={{padding:"16px 24px 24px"}}>
          {/* Infos */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:18}}>
            {[
              ["👤 Client",     i.client_nom||"—"],
              ["📍 Adresse",    [i.client_adresse,i.client_ville].filter(Boolean).join(", ")||"—"],
              ["🔧 Technicien", i.technicien_nom||"Non assigné"],
              ["🕐 Date",       i.date_planifiee?new Date(i.date_planifiee).toLocaleString("fr-FR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}):"—"],
              ["🏷️ Type",       i.type_intervention||i.type||"—"],
              ["📅 Créé le",    new Date(i.created_at).toLocaleDateString("fr-FR")],
            ].map(([label,val])=>(
              <div key={label} style={{background:T.bg,borderRadius:10,padding:"10px 13px",border:`1px solid ${T.border}`}}>
                <div style={{fontSize:11,color:T.muted,marginBottom:3}}>{label}</div>
                <div style={{fontSize:13,fontWeight:600,color:T.text}}>{val}</div>
              </div>
            ))}
          </div>

          {i.eta_depot_distance_km!=null&&(
            <div style={{display:"flex",alignItems:"center",gap:10,background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:10,padding:"10px 14px",marginBottom:i.eta_route_distance_km!=null?10:18}}>
              <span style={{fontSize:18}}>🚦</span>
              <div>
                <div style={{fontSize:12.5,fontWeight:700,color:T.text}}>
                  {i.eta_depot_distance_km} km depuis le siège · {i.eta_depot_duree_min} min de trajet
                </div>
                {i.eta_depot_arrivee&&<div style={{fontSize:11,color:T.muted}}>Arrivée estimée à {new Date(i.eta_depot_arrivee).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}</div>}
              </div>
            </div>
          )}

          {i.eta_route_distance_km!=null&&(
            <div style={{display:"flex",alignItems:"center",gap:10,background:i.eta_route_retard?"#ef444415":"#10b98115",border:`1px solid ${i.eta_route_retard?"#ef4444":"#10b981"}40`,borderRadius:10,padding:"10px 14px",marginBottom:18}}>
              <span style={{fontSize:18}}>{i.eta_route_retard?"⚠️":"✅"}</span>
              <div>
                <div style={{fontSize:12.5,fontWeight:700,color:i.eta_route_retard?"#ef4444":"#10b981"}}>
                  {i.eta_route_retard?"Risque de retard":"Trajet dans les temps"} depuis l'intervention précédente
                </div>
                <div style={{fontSize:11,color:T.muted}}>
                  {i.eta_route_distance_km} km · {i.eta_route_duree_min} min
                  {i.eta_route_arrivee&&` · arrivée estimée ${new Date(i.eta_route_arrivee).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}`}
                </div>
              </div>
            </div>
          )}

          {/* Mini carte */}
          <div style={{marginBottom:18}}>
            <button onClick={()=>setShowMap(!showMap)}
              style={{display:"flex",alignItems:"center",gap:8,padding:"9px 14px",borderRadius:10,border:`1px solid ${T.border}`,background:showMap?T.accentDim:"transparent",color:showMap?T.accent:T.muted,fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:showMap?10:0,width:"100%",justifyContent:"space-between"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span>🗺️</span>
                <span>Voir sur la carte · {adresseComplete}</span>
              </div>
              <span>{showMap?"▲":"▼"}</span>
            </button>
            {showMap&&(
              <div style={{borderRadius:12,overflow:"hidden",border:`1px solid ${T.border}`,position:"relative"}}>
                <iframe
                  src={osmEmbedUrl}
                  width="100%" height="200" frameBorder="0"
                  style={{display:"block"}}
                  title="Carte intervention"
                />
                <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"8px 12px",background:"rgba(0,0,0,0.6)",display:"flex",gap:8,justifyContent:"flex-end"}}>
                  <a href={googleMapsUrl} target="_blank" rel="noreferrer"
                    style={{padding:"6px 12px",borderRadius:8,background:"#4285f4",color:"#fff",fontSize:12,fontWeight:700,textDecoration:"none",display:"flex",alignItems:"center",gap:6}}>
                    <span>📍</span> Ouvrir Google Maps
                  </a>
                  <a href={`https://waze.com/ul?q=${encodeURIComponent(adresseComplete)}`} target="_blank" rel="noreferrer"
                    style={{padding:"6px 12px",borderRadius:8,background:"#33ccff",color:"#fff",fontSize:12,fontWeight:700,textDecoration:"none",display:"flex",alignItems:"center",gap:6}}>
                    <span>🚗</span> Waze
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Description */}
          {i.description&&(
            <div style={{background:T.bg,borderRadius:10,padding:"12px 14px",border:`1px solid ${T.border}`,marginBottom:18}}>
              <div style={{fontSize:11,color:T.muted,marginBottom:4,fontWeight:700,textTransform:"uppercase"}}>Description</div>
              <div style={{fontSize:13,color:T.mutedL,lineHeight:1.6}}>{i.description}</div>
            </div>
          )}

          {/* Progression */}
          <div style={{marginBottom:18}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:12}}>Progression</div>
            <div style={{display:"flex",alignItems:"center"}}>
              {steps.map((s,idx)=>{
                const done=idx<=currentIdx;
                const current=idx===currentIdx;
                return(
                  <div key={s} style={{display:"flex",alignItems:"center",flex:idx<2?1:"auto"}}>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5}}>
                      <div style={{width:34,height:34,borderRadius:"50%",background:done?"#22d3a0":T.bg,border:`2px solid ${current?"#22d3a0":done?"#22d3a0":T.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:done?"#fff":T.muted}}>
                        {done&&!current?"✓":idx+1}
                      </div>
                      <div style={{fontSize:10,color:done?"#22d3a0":T.muted,fontWeight:600,whiteSpace:"nowrap"}}>{stepLabels[idx]}</div>
                    </div>
                    {idx<2&&<div style={{flex:1,height:2,background:idx<currentIdx?"#22d3a0":T.border,margin:"0 6px",marginBottom:22}}/>}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Actions statut */}
          {NEXT[statut]&&(
            <div style={{marginBottom:18}}>
              <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:10}}>Actions</div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                {NEXT[statut].map(a=>(
                  <button key={a.s} onClick={()=>changeStatut(a.s)} disabled={updating}
                    style={{padding:"9px 16px",borderRadius:10,border:`1.5px solid ${a.c}`,background:a.c+"18",color:a.c,fontSize:13,fontWeight:700,cursor:"pointer",opacity:updating?0.6:1}}>
                    {a.lbl}
                  </button>
                ))}
                <button onClick={()=>setShowReassign(!showReassign)}
                  style={{padding:"9px 14px",borderRadius:10,border:`1px solid ${T.warning}`,background:T.warningDim,color:T.warning,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  🔀 Réassigner
                </button>
              </div>
            </div>
          )}

          {/* Réassignation */}
          {showReassign&&(
            <div style={{background:T.warningDim,border:`1px solid ${T.warning}40`,borderRadius:12,padding:16,marginBottom:18}}>
              <div style={{fontSize:13,fontWeight:700,color:T.warning,marginBottom:12}}>🔀 Réassigner à un autre technicien</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                <select value={newTech} onChange={e=>setNewTech(e.target.value)}
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:14,outline:"none"}}>
                  <option value="">— Choisir —</option>
                  {techniciens.filter(t=>t.id!==i.technicien_id).map(t=>(
                    <option key={t.id} value={t.id}>{t.prenom} {t.nom}</option>
                  ))}
                </select>
                <input value={comment} onChange={e=>setComment(e.target.value)} placeholder="Raison (optionnel)"
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:13,outline:"none"}}/>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setShowReassign(false)} style={{flex:1,padding:"8px",borderRadius:9,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,cursor:"pointer"}}>Annuler</button>
                  <button onClick={reassigner} disabled={!newTech||updating}
                    style={{flex:2,padding:"8px",borderRadius:9,background:newTech?"#f5a623":T.border,border:"none",color:"#fff",fontWeight:700,cursor:newTech?"pointer":"not-allowed"}}>
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* BOUTON PV — Principal */}
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <button
              onClick={()=>onShowSuggestions&&onShowSuggestions()}
              style={{width:"100%",padding:"11px",borderRadius:11,background:`${T.warning}18`,border:`1px solid ${T.warning}50`,color:T.warning,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
              <span>📍</span> Interventions à proximité
            </button>
            <button
              onClick={()=>{ if(onOpenPV) onOpenPV(); }}
            style={{width:"100%",padding:"16px",borderRadius:13,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:16,fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:12,boxShadow:`0 4px 20px ${T.accent}40`}}>
              <span style={{fontSize:22}}>📋</span>
              <span>Ouvrir le PV d'intervention</span>
              {i.modele_pv&&<span style={{fontSize:12,background:"rgba(255,255,255,0.2)",padding:"3px 10px",borderRadius:20}}>{MODELE_LABELS[i.modele_pv]||i.modele_pv}</span>}
            </button>
            {!showSigForm ? (
              <button
                onClick={() => { setShowSigForm(true); setSigEmail(i.client_email || ""); }}
                style={{width:"100%",padding:"13px",borderRadius:11,background:"#e0f2fe",border:"1.5px solid #7dd3fc",color:"#0369a1",fontSize:14,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
                <span style={{fontSize:18}}>📧</span>
                Envoyer le lien de signature au client
              </button>
            ) : (
              <div style={{background:"#f0f9ff",border:"1.5px solid #7dd3fc",borderRadius:11,padding:"14px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#0369a1",marginBottom:8}}>📧 Adresse email du destinataire</div>
                <input
                  type="email"
                  value={sigEmail}
                  onChange={e => setSigEmail(e.target.value)}
                  placeholder="email@client.fr"
                  autoFocus
                  style={{width:"100%",padding:"9px 12px",borderRadius:8,border:"1px solid #7dd3fc",background:"#fff",color:"#0f172a",fontSize:13,outline:"none",boxSizing:"border-box",marginBottom:10}}
                />
                <div style={{display:"flex",gap:8}}>
                  <button
                    onClick={sendSignatureLink}
                    disabled={sendingLink || !sigEmail.trim()}
                    style={{flex:1,padding:"9px",borderRadius:8,background:"#0369a1",border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:sendingLink||!sigEmail.trim()?"not-allowed":"pointer",opacity:sendingLink||!sigEmail.trim()?0.7:1}}>
                    {sendingLink ? "Envoi…" : "📨 Envoyer"}
                  </button>
                  <button
                    onClick={() => setShowSigForm(false)}
                    style={{padding:"9px 14px",borderRadius:8,background:"transparent",border:"1px solid #cbd5e1",color:"#64748b",fontSize:13,cursor:"pointer"}}>
                    Annuler
                  </button>
                </div>
              </div>
            )}
            <button onClick={()=>onExportPDF&&onExportPDF()}
              style={{width:"100%",padding:"11px",borderRadius:10,background:`${T.success}18`,border:`1.5px solid ${T.success}50`,color:T.success,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
              <span>📄</span> Exporter / Imprimer le PV
            </button>
            {intervention.modele_pv==="pack_flash"&&(
              <button onClick={()=>onFicheConsigne&&onFicheConsigne()}
                style={{width:"100%",padding:"11px",borderRadius:11,background:`${T.danger}18`,border:`1.5px solid ${T.danger}50`,color:T.danger,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
                🚨 Fiche de Consigne Télésurveillance
              </button>
            )}
            {intervention.modele_pv==="pack_sentinelle"&&(
              <button onClick={()=>onZonesCameras&&onZonesCameras()}
                style={{width:"100%",padding:"11px",borderRadius:11,background:`${T.accent}18`,border:`1.5px solid ${T.accent}50`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
                📷 Fiche Zones Caméras
              </button>
            )}
            <button onClick={()=>onChecklist&&onChecklist()}
              style={{width:"100%",padding:"11px",borderRadius:11,background:`${T.success}15`,border:`1px solid ${T.success}40`,color:T.success,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
              ☑️ Check-list opérationnelle
            </button>
            <button onClick={()=>onNonConf&&onNonConf()}
              style={{width:"100%",padding:"11px",borderRadius:11,background:`${T.warning}15`,border:`1px solid ${T.warning}40`,color:T.warning,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:8}}>
              ⚠️ Réserves & Non-conformités
            </button>
            <button onClick={onClose} style={{width:"100%",padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    {sigToast && (
      <div style={{position:"fixed",top:24,right:24,zIndex:9999,background:"#1e293b",color:"#fff",padding:"11px 20px",borderRadius:12,fontSize:13,fontWeight:600,boxShadow:"0 8px 24px #00000044",pointerEvents:"none"}}>
        {sigToast}
      </div>
    )}
    </>
  );
}
